import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import MEDIA_CONFIG from './config';

// `:path+` is a repeatable param, and router 4 hands one back as the array of its
// segments where router 3 gave the joined string. UsersMediaPage splits it on '/'
// again, so join it back here rather than changing what the page reads
const withJoinedPath = route => ({
    ...route.params,
    path: [].concat(route.params.path || []).join('/')
});

export default defineSection({
    head: sectionHead({title: 'Media', icon: FAVICONS.media}),
    // the section's stylesheet used to come in through its entry point; it belongs
    // to the section's chunk, not to the bundle every page loads
    setup: () => import(/* webpackChunkName: "media" */ './styles/folders.scss'),
    routes: [
        {
            path: MEDIA_CONFIG.MAIN_MEDIA_PREFIX + 'list/',
            component: () => import(/* webpackChunkName: "media" */ './FoldersIManageList.vue'),
            props: true
        },
        {
            path: MEDIA_CONFIG.MAIN_MEDIA_PREFIX + ':username/',
            component: () => import(/* webpackChunkName: "media" */ './users_media/UsersMediaPage.vue'),
            props: true
        },
        {
            path: MEDIA_CONFIG.MAIN_MEDIA_PREFIX + 'access-code/:accessCode/:username/',
            component: () => import(/* webpackChunkName: "media" */ './users_media/UsersMediaPage.vue'),
            props: true
        },
        {
            path: MEDIA_CONFIG.MAIN_MEDIA_PREFIX + ':userName/:userId/settings/',
            component: () => import(/* webpackChunkName: "media" */ './access_table/MediaManageAccessPage.vue'),
            props: true
        },
        {
            path: MEDIA_CONFIG.MAIN_MEDIA_PREFIX + 'access-code/:accessCode/:username/:path+/',
            component: () => import(/* webpackChunkName: "media" */ './users_media/UsersMediaPage.vue'),
            props: withJoinedPath
        },
        {
            path: MEDIA_CONFIG.MAIN_MEDIA_PREFIX + ':username/:path+/',
            component: () => import(/* webpackChunkName: "media" */ './users_media/UsersMediaPage.vue'),
            props: withJoinedPath
        }
    ]
});
